import React from 'react';

class ProposedChanges extends React.Component {

    constructor(props) {
        super(props);
    }
    
    render() {
        const strawPolliFrame = {width:'100%', height:1044, overflow:'hidden', border:0};
        return (
            <div id="ProposedChangesContainer">
                <h2>Proposed Changes for 2022</h2>
                {/* <div>
                    <h3>Move to ESPN/Yahoo</h3>
                    <ul>
                        <li>Yahoo con: "Yahoo trash" - Zane</li>
                        <li>ESPN con: no first down scoring</li>
                    </ul>
                    <iframe src="http://www.strawpoll.me/embed_1/42902610" style={strawPolliFrame}>Loading poll...</iframe>
                    <iframe src="http://www.strawpoll.me/embed_1/42902610" style={strawPolliFrame}>Loading poll...</iframe>
                </div> */}
                {/* <div>
                    <iframe src="https://strawpoll.com/embed/d5okqoh6s" style={strawPolliFrame} frameborder="0"></iframe>
                </div> */}
                <ul>
                    <li>Add 3 year contracts until week 3</li>
                    <li>Defensive scoring update</li>
                    <li>Add salaries for 2025/26 season</li>
                    <li>Lottery results only count for the first round of the draft</li>
                    <li>Third IR slot</li>
                    <li>After a franchise tagged player is dropped, they cannot be tagged again in that same year</li>
                    <li>Remove franchise tags altogether</li>
                    <li>"Battle Royale" style week 1 and 14, top 6 scores get a win, others get a loss. Sacko plays champion twice, 11th plays 2nd twice...</li>
                </ul>
            </div>
        );
    }
}

export default ProposedChanges;